import React from 'react'
import { Button, Card, Label } from 'semantic-ui-react'
import _ from 'lodash'
import moment from 'moment'

const styles = {
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
}

const CategorySectionCard = ({ mealTime, categoryName, onEditClick }) => {
  return (
    <Card>
      <Card.Content>
        <Card.Header>{mealTime.title}</Card.Header>
        <Card.Description>
          <div style={styles.listContentWrapper}>
            <div style={{ display: 'flex', flex: 1 }}>Category:</div>
            <div style={{ display: 'flex' }}>
              <Label>{categoryName}</Label>
            </div>
          </div>
          <div style={styles.listContentWrapper}>
            <div style={{ display: 'flex', flex: 1 }}>Start From:</div>
            <div style={{ display: 'flex' }}>
              <Label>{moment(mealTime.started_at).format('DD-MMM-YYYY')}</Label>
            </div>
          </div>
          <div style={styles.listContentWrapper}>
            <div style={{ display: 'flex', flex: 1 }}>Expired At:</div>
            <div style={{ display: 'flex' }}>
              <Label>{moment(mealTime.expired_at).format('DD-MMM-YYYY')}</Label>
            </div>
          </div>

          <div>
            {_.map(mealTime.time_frame, (dayTimeFrame, day) => (
              <div style={styles.listContentWrapper}>
                <div style={{ display: 'flex', flex: 1 }}>{_.capitalize(day)}</div>
                <div style={{ display: 'flex' }}>
                  <Label>
                    {moment(dayTimeFrame.from, 'HH:mm').format('hh:mm a')} -
                    {moment(dayTimeFrame.to, 'HH:mm').format('hh:mm a')}
                  </Label>
                </div>
              </div>
            ))}
          </div>
        </Card.Description>
      </Card.Content>
      <Card.Content extra>
        <div>
          <Button color="black" size="tiny" fluid onClick={onEditClick}>
            Edit
          </Button>
        </div>
      </Card.Content>
    </Card>
  )
}

export default CategorySectionCard



// WEBPACK FOOTER //
// ./src/containers/category/components/CategorySectionCard.js